import { GetApiV5FirmsFilesTag } from '@liscio/api';

/** The Inbox source filter; `all` is every file awaiting review. */
export type InboxSource = 'all' | 'client_upload' | 'file_connect';

export const INBOX_SOURCES: ReadonlyArray<{
  value: InboxSource;
  label: string;
}> = [
  { value: 'all', label: 'All' },
  { value: 'client_upload', label: 'Client uploads' },
  { value: 'file_connect', label: 'FileConnect' },
];

export function parseInboxSource(raw: string | null): InboxSource {
  return raw === 'client_upload' || raw === 'file_connect' ? raw : 'all';
}

export interface InboxSourceFilters {
  tag?: GetApiV5FirmsFilesTag;
  uploader_id?: number;
}

/**
 * Index filters for a source. FileConnect is the current user's own SharePoint imports (the import
 * stores the connection owner as uploader), the same predicate as the app-wide banner count, so it
 * returns null until the user's membership id is known rather than querying unscoped.
 */
export function inboxSourceFilters(
  source: InboxSource,
  cpaUserId: number | undefined
): InboxSourceFilters | null {
  if (source === 'client_upload') {
    return { tag: GetApiV5FirmsFilesTag.client_upload };
  }
  if (source === 'file_connect') {
    return cpaUserId == null
      ? null
      : {
          tag: GetApiV5FirmsFilesTag.SharePoint_Import,
          uploader_id: cpaUserId,
        };
  }
  return {};
}

/** Files → Inbox → FileConnect, with no chip, keyword, preview or page carried over. */
export const fileConnectQueuePath = (filesPath: string) =>
  `${filesPath}?${new URLSearchParams({
    view: 'list',
    source: 'file_connect',
  }).toString()}`;
